import { useParams } from 'react-router-dom';

import type { PermissionTag } from '@vlabs/api/artemy/model';

export function usePermissionTagFromLocation(): PermissionTag {
  const { permissionTag } = useParams<{ permissionTag: PermissionTag }>();

  return permissionTag;
}
